export function hasAdminRights(myAccount) {
  return myAccount?.permission < 3;
}
